import { useEffect, useState } from 'react';
import { del, get, set } from 'idb-keyval';

const useCacheValue = ({ value, setValue, cacheId }) => {
  const [cacheLoading, setCacheLoading] = useState(true);

  useEffect(() => {
    if (!cacheId) return;
    get(cacheId)
      .then((valueFromCache) => {
        if (valueFromCache) setValue(valueFromCache);
      })
      .finally(() => setCacheLoading(false));
  }, [cacheId]);

  useEffect(() => {
    if (cacheLoading) return;
    if (!Object.keys(value).length) {
      del(cacheId);
      return;
    }
    set(cacheId, value);
  }, [value]);

  return {
    cacheLoading,
  };
};

export default useCacheValue;
